angular.module('bribac.components.insuranceProviderEditor', [
    'bribac.values',
    'bribac.translations',
    'bribac.services.api'
])
    .component('insuranceProviderEditor', {
        bindings: {
            editableInsuranceProvider: '<',
            saveCallback: '&',
            cancelCallback: '&',
            isSubmitting: '<',
        },
        templateUrl: 'insurance-provider-editor-component.html',
        controller: 'InsuranceProviderEditorCtrl'
    })
    .controller('InsuranceProviderEditorCtrl', function (
        $scope,
        api,
        KINDS,
        permissions
    ) {
        const $ctrl = this;

        $ctrl.permissions = permissions;

        $ctrl.saveInsuranceProviderData = function () {
            var $form = $ctrl.form

            if ($form._submitting) return

            if ($form.$invalid) {
                $form._submitError = 'formErrors.invalidFields'
                return
            }

            if (!($ctrl.editableInsuranceProvider.mainGroupsIds || []).length) {
                $form._submitError = 'At least one main group is required';
                return;
            }

            $form._submitSuccess = ''
            $form._submitError = ''

            $ctrl.editableInsuranceProvider.mainGroupsIds = ($ctrl.editableInsuranceProvider.mainGroupsIds || [])
                .map(group => group.id);

            $ctrl.isSubmitting = true;
            $ctrl.saveCallback({
                data: $ctrl.editableInsuranceProvider,
            }).finally(() => {
                $ctrl.isSubmitting = false;
            });
        };

        $ctrl.cancelInsuranceProviderForm = function () {
            $ctrl.cancelCallback();
        };

        function initializeEditableInsuranceProvider() {
            if (!$ctrl.editableInsuranceProvider) {
                $ctrl.editableInsuranceProvider = {
                    username: '',
                    lastName: '',
                    firstName: '',
                    middleName: '',
                    npi: '',
                    mainGroupsIds: []
                };
            } else if (!$ctrl.editableInsuranceProvider.mainGroupsIds) {
                $ctrl.editableInsuranceProvider.mainGroupsIds = [];
            }
            generateUsername();
            generateProviderId();
        }

        function generateUsername() {
            const lastName = $ctrl.editableInsuranceProvider.lastName || '';

            if (lastName) {
                $ctrl.editableInsuranceProvider.username = `${lastName}`.toUpperCase();
            } else {
                $ctrl.editableInsuranceProvider.username = '';
            }
        }

        function generateProviderId() {
            const lastName = $ctrl.editableInsuranceProvider.lastName || '';
            const firstName = $ctrl.editableInsuranceProvider.firstName || '';
            const npi = $ctrl.editableInsuranceProvider.npi || '';

            if (lastName && firstName && npi.length >= 3) {
                $ctrl.editableInsuranceProvider.providerId = `${firstName.charAt(0)}${lastName.charAt(0)}${npi.slice(-3)}`.toUpperCase();
            } else {
                $ctrl.editableInsuranceProvider.providerId = '';
            }
        }

        function reload() {
            const filter = $ctrl.organization ? `?organization=${$ctrl.organization.id}` : '';

            $ctrl.mainGroupsPromise = api.getFilteredByOrg(KINDS.MAIN_GROUP, filter)
                .then(function (response) {
                    $ctrl.mainGroups = response.data.list;

                    initializeEditableInsuranceProvider();

                    if (!$ctrl.editableInsuranceProvider.mainGroupsIds) {
                        $ctrl.editableInsuranceProvider.mainGroupsIds = [];
                    }

                    const availableIds = $ctrl.mainGroups.map(group => group.id);
                    $ctrl.editableInsuranceProvider.mainGroupsIds = $ctrl.editableInsuranceProvider.mainGroupsIds.filter(id => availableIds.includes(id));
                })
        }

        $scope.$watch('$ctrl.organization', function (newVal, oldVal) {
            if (newVal !== oldVal) {
                reload();
            }
        });

        $scope.$watch('$ctrl.editableInsuranceProvider.npi', generateProviderId);
        $scope.$watch('$ctrl.editableInsuranceProvider.lastName', generateUsername);
        $scope.$watch('$ctrl.editableInsuranceProvider.lastName', generateProviderId);
        $scope.$watch('$ctrl.editableInsuranceProvider.firstName', generateProviderId);

        $ctrl.$onInit = function () {
            initializeEditableInsuranceProvider();
            reload();
        };
    });